<template>
<div class="chapter">
<div class="inner_page">
<p class="ct" id="d6e62">The EVERYTHING® Self-Esteem Book </p>
<p class="tx" id="d6e142">Reader:</p>
<p class="tx" id="d6e192">I ran away from home on a Monday. I left the South and ran to D.C., Dear to New York Cit y, and further north. Sadly, I did not find happiness or joy at any stop. I didn’t find validation and I didn’t find any place that made me feel any better about myself. <i>Where is my happiness? </i>I questioned. <i>Why is no one here to rescue me? Why? Why? Why?</i></p>
<p class="tx" id="d6e432">I did not have happiness in my heart, my work, my relationships, my traveled for days trying to lose didn’t like me, and I life. I years to home, self-esteem or my years old. It took me twenty-seven I was twenty-seven me that myself. cannot run from ourselves. That trip taught realize that we running; it’s about stopping.</p>
<p class="tx" id="d6e602">In this book, I share the advice and activities that have helped others, and me, over the years. I provide a framework so that <i>you can begin your </i><i>wor k </i>to better understand your worth, carve a path to your happiness, uncove r your purpose in life, and move toward an inner peace about the gifts and challenges bestowed on you as a human being.</p>
<p class="tx" id="d6e882">All the best to you, </p>
<p class="ser1"><img alt="9781580629768_ps_0002_001" id="d14e56" src="images/9781580629768_ps_0002_001.jpg" style="max-width: 100%"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Sher_9781440522697_epub_c3_r1.vue?c2a1c394